import { render, staticRenderFns } from "./token.modal.vue?vue&type=template&id=40a77a7d&"
import script from "./token.modal.vue?vue&type=script&lang=js&"
export * from "./token.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports